import { Minus, TrendingDown, TrendingUp } from "lucide-react";
import type { ReactNode } from "react";
import { Heading } from "../atoms/Heading";
import { Text } from "../atoms/Text";
import { cn } from "../lib/cn";

export type TrendDirection = "up" | "down" | "flat";

const TREND_ICONS: Record<TrendDirection, ReactNode> = {
	up: <TrendingUp className="h-4 w-4 text-statusSuccess" aria-hidden="true" />,
	down: (
		<TrendingDown className="h-4 w-4 text-destructive" aria-hidden="true" />
	),
	flat: <Minus className="h-4 w-4 text-mutedForeground" aria-hidden="true" />,
};

export interface MetricTileProps {
	label: string;
	value: string | number;
	trend?: TrendDirection;
	trendLabel?: string;
	helpText?: string;
	className?: string;
}

function MetricTile({
	label,
	value,
	trend,
	trendLabel,
	helpText,
	className,
}: MetricTileProps): ReactNode {
	return (
		<div
			className={cn(
				"flex flex-col gap-2 rounded-lg border border-border bg-card p-4",
				className,
			)}
		>
			<Text size="sm" textColor="mutedForeground">
				{label}
			</Text>
			<Heading size="2xl" as="h3">
				{value}
			</Heading>
			{(trend || trendLabel) && (
				<div className="flex items-center gap-1">
					{trend && TREND_ICONS[trend]}
					{trendLabel && (
						<Text size="xs" textColor="mutedForeground">
							{trendLabel}
						</Text>
					)}
				</div>
			)}
			{helpText && (
				<Text size="xs" textColor="mutedForeground">
					{helpText}
				</Text>
			)}
		</div>
	);
}
MetricTile.displayName = "MetricTile";

export default MetricTile;
export { MetricTile };
